$(document).ready(function () {
	window.chenDatepicker = $.fn.datepicker.noConflict();
	$.fn.chenDatepicker = window.chenDatepicker;
	initBooking();
});

function initBooking() {
	//$('#booking').foundation('open');
	
	$('.header__book > .button').on('click', function () {
		$('.header__book-options').slideToggle();
		$('.header__book-options').toggleClass('open');
	});

	var scrollOffset = 0;
	var scrollCount = 0;
	$(window).on('scroll', function() {
		if( $('.header__book-options').hasClass('open') ) {
			var currentScrollOffset = $(window).scrollTop();
			if (currentScrollOffset > scrollOffset) {
				scrollCount -= 1;
			} else {
				scrollCount += 1;
			}
			scrollOffset = currentScrollOffset;

			if( scrollOffset > 50 ) {
				$('.header__book > .button').trigger('click');
			}
		}
	})
	
//	$('.header__book-rooms').on('click', function () {
//		openBooking('rooms');
//		$('.header__book-options').slideUp();
//	});
	
	$('.header__book-cottages').on('click', function () {
		openBooking('cottages');
		$('.header__book-options').slideUp();
	});
	
	$('.header__book-table').on('click', function () {
		openBooking('tables');
		$('.header__book-options').slideUp();
	});

	$('a[href="#book-spa"]').on('click', function () {
		openBooking('spa');
		$('.header__book-options').slideUp();
	});

	$('a[href="#book-experience').on('click', function () {
		openBooking('experience');
		$('.header__book-options').slideUp();
	});
	
	$('a[href="#book-table"]').on('click', function () {
		openBooking('tables');
		return false;
	});
	
	$('a[href="#book-the-deck"]').on('click', function () {
		openBooking('the-deck');
		return false;
	});
	
	$('a[href="#book-the-terrace"]').on('click', function () {
		openBooking('the-terrace');
		return false;
	});
	
	$('a[href="#book-the-samphire"]').on('click', function () {
		openBooking('the-samphire');
		return false;
	});

	$('a[href="#book-afternoon-tea"]').on('click', function () {
		openBooking('afternoon-tea');
		return false;
	});
	
	$('.booking__quantity-up').on('click', function (e) {
		e.preventDefault();
		
		var $field = $(this).prev();
		var fieldValue = $field.val();
		
		if ( fieldValue < $field.attr('max') ) {
			fieldValue++;
			$field.val(fieldValue);
		}
	});
	
	$('.booking__quantity-down').on('click', function (e) {
		e.preventDefault();
		
		var $field = $(this).next();
		var fieldValue = $field.val();
		
		if ( fieldValue > $field.attr('min') ) {
			fieldValue--;
			$field.val(fieldValue);
		}
	});
	
	$('.booking__why').accordiom({
		showFirstItem: false
	});
}



function openBooking(bookingType) {
	$('select[name="roomType"]').selectric('destroy');
	$('select[name="roomType"]').empty();
	var isCottage 
	
	if ( bookingType === 'rooms' ) {
		isCottage = false
		$('.booking__column.departure label').html('Departure')
		$('.booking__header--rooms').show();
		$('.booking__header--cottages').hide();
		$('.booking__tables').hide();
		$('.booking__spa').hide();
		$('.booking__experience').hide();
		$('.booking__rooms').css('display', 'flex');
		$('input[name="buildingCode"]').val('hot');
		$('select[name="roomType"]').html('<option value="any">All</option><option value="bd">Best Double</option><option value="bfs">Best Family Suite</option><option value="bs">Best Suite</option><option value="cd">Coastal Double</option><option value="cs">Coastal Suite</option><option value="fd">Fistral Double</option><option value="fs">Fistral Suite</option><option value="gd">Grounds Double</option><option value="gf">Grounds Family</option><option value="gs">Grounds Suite</option><option value="od">Ocean Double</option><option value="of">Ocean Family</option><option value="os">Ocean Suite</option><option value="xd">Cosy</option>');
		
	} else if ( bookingType === 'cottages' ) {
		isCottage = true
		$('.booking__column.departure label').html('Departure <small>(min 3)</small>')
		$('.booking__header--rooms').hide();
		$('.booking__header--cottages').show();
		$('.booking__rooms').css('display', 'flex');
		$('.booking__tables').hide();
		$('.booking__spa').hide();
		$('.booking__experience').hide();
		$('input[name="buildingCode"]').val('cot');
		$('select[name="roomType"]').html('	<option value="any">All</option><option value="acc2vv">2-bedroom Cottage with hot tub</option><option value="c1sv">1-bedroom Cottage Sea View</option><option value="c1vv">1-bedroom Cottage Village View</option><option value="c2sv">2-bedroom Cottage Sea View</option><option value="c2vv">2-bedroom Cottage Village View</option><option value="c3sv">3-bedroom Cottage Sea View</option><option value="c3vv">3-bedroom Cottage Village View</option><option value="m562">Mariners 2</option>');


	} else if (bookingType === 'tables') {
		$('.booking__rooms').css('display', 'none');
		$('.booking__tables').hide();
		$('.booking__tables--global').show();
		$('.booking__spa').hide();
		$('.booking__experience').hide();
		$('.booking__tables--global iframe').each(function () {
			$(this).attr('src', $(this).data('lazy-src'));
		});
	} else if (bookingType === 'the-deck') {
		$('.booking__rooms').css('display', 'none');
		$('.booking__tables').hide();
		$('.booking__tables--the-deck').show();
		$('.booking__spa').hide();
		$('.booking__experience').hide();
		$('.booking__tables--the-deck iframe').each(function () {
			$(this).attr('src', $(this).data('lazy-src'));
		});
	} else if (bookingType === 'the-terrace') {
		$('.booking__rooms').css('display', 'none');
		$('.booking__tables').hide();
		$('.booking__tables--the-terrace').show();
		$('.booking__spa').hide();
		$('.booking__experience').hide();
		$('.booking__tables--the-terrace iframe').each(function () {
			$(this).attr('src', $(this).data('lazy-src'));
		});
	} else if (bookingType === 'the-samphire') {
		$('.booking__rooms').css('display', 'none');
		$('.booking__tables').hide();
		$('.booking__tables--the-samphire').show();
		$('.booking__spa').hide();
		$('.booking__experience').hide();
		$('.booking__tables--the-samphire iframe').each(function () {
			$(this).attr('src', $(this).data('lazy-src'));
		});
	} else if (bookingType === 'afternoon-tea') {
		$('.booking__rooms').css('display', 'none');
		$('.booking__tables').hide();
		$('.booking__tables--afternoon-tea').show();
		$('.booking__spa').hide();
		$('.booking__experience').hide();
		$('.booking__tables--afternoon-tea iframe').each(function () {
			$(this).attr('src', $(this).data('lazy-src'));
		});
	} else if (bookingType === 'spa') {
		$('.booking__rooms').css('display', 'none');
		$('.booking__tables').hide();
		$('.booking__tables--afternoon-tea').hide();
		$('.booking__experience').hide();
		$('.booking__spa').show();

		function handleSpaOptions() {
			var toggleDropdown = $('.booking__spa .booking__visit-type__toggle')

			var optionsDiv = $('.booking__spa .booking__visit-type__options')
			var hotelForm = $('.booking__spa .booking__spa-hotel-form')
			var dayForm = $('.booking__spa .booking__spa-day-form')
			var hotelBtn = $('.booking__spa .booking__visit-type__hotel')
			var dayBtn = $('.booking__spa .booking__visit-type__day')

			toggleDropdown.on('click', function () {
				optionsDiv.toggleClass('show')
				hotelForm.removeClass('show')
				dayForm.removeClass('show')
			})

			hotelBtn.on('click', function () {
				hotelForm.addClass('show')
				optionsDiv.removeClass('show')
				dayForm.removeClass('show')
				toggleDropdown.text($(this).text())
			})

			dayBtn.on('click', function () {
				dayForm.addClass('show')
				optionsDiv.removeClass('show')
				hotelForm.removeClass('show')
				toggleDropdown.text($(this).text())
			})

		}
		handleSpaOptions()
		
	} else if (bookingType === 'experience') {
		$('.booking__rooms').css('display', 'none');
		$('.booking__tables').hide();
		$('.booking__tables--afternoon-tea').hide();
		$('.booking__spa').hide();
		$('.booking__experience').show();
		$('.booking__experience-day-form iframe').each(function () {
			$(this).attr('src', $(this).data('lazy-src'));
		});

		function handleExpOptions() {
			var toggleDropdown = $('.booking__experience .booking__visit-type__toggle')

			var optionsDiv = $('.booking__experience .booking__visit-type__options')
			var hotelForm = $('.booking__experience .booking__experience-hotel-form')
			var dayForm = $('.booking__experience .booking__experience-day-form')
			var hotelBtn = $('.booking__experience .booking__visit-type__hotel')
			var dayBtn = $('.booking__experience .booking__visit-type__day')

			toggleDropdown.on('click', function () {
				optionsDiv.toggleClass('show')
				hotelForm.removeClass('show')
				dayForm.removeClass('show')
			})

			hotelBtn.on('click', function () {
				hotelForm.addClass('show')
				optionsDiv.removeClass('show')
				dayForm.removeClass('show')
				toggleDropdown.text($(this).text())
			})

			dayBtn.on('click', function () {
				dayForm.addClass('show')
				optionsDiv.removeClass('show')
				hotelForm.removeClass('show')
				toggleDropdown.text($(this).text())
			})

		}
		handleExpOptions()
	}


	
	$('select[name="roomType"]').selectric();
	
	$('#booking').foundation('open');
	var isCottage = $('input[name="buildingCode"]').val() === 'cot'

	var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	var dayNames   = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ];
	
	var bookingContainer = $('.booking__rooms');

	
	var nowTemp = new Date();	
	var tomorrow = new Date();
		tomorrow.setDate(nowTemp.getDate() + 1);
		

	var $checkInField = bookingContainer.find('.check-in');
	var $checkOutField = bookingContainer.find('.check-out');

	var checkinDay;
	var checkoutDay;

	$checkInField.on('hide.datepicker', function () {
		var checkInDate  = $checkInField.chenDatepicker('getDate');
		var checkOutDate = $checkOutField.chenDatepicker('getDate');
		var dayAfterCheckIn = new Date(checkInDate);
			dayAfterCheckIn.setDate(checkInDate.getDate() + 1);
		

		// Ensure checkout comes after checkin.
		// Otherwise it all gets a bit Restaurant at the End of the Universe-ey.
		if ( checkInDate >= checkOutDate ) {
			$checkOutField.chenDatepicker('setDate', dayAfterCheckIn);
		}

		$checkOutField.chenDatepicker('setStartDate', dayAfterCheckIn);

		$checkOutField[0].focus();


		checkinDay = new Date(checkInDate).setUTCHours(0,0,0,0)
		checkoutDay = new Date(checkOutDate).setUTCHours(0,0,0,0)
		//console.log(checkinDay, checkoutDay)
		var diff = checkoutDay - checkinDay
		var nights = diff / (1000 * 60 * 60 * 24);
		//console.log(diff, nights)
		$('input[name="nightsStay"]').val(nights) 
	});



	

	var checkin = $checkInField.chenDatepicker({
		format: 'dd/mm/yyyy',
		autoPick: true,
		autoHide: true,
		date: null,
		startDate: nowTemp,
		pick: function (e) {
			$('.check-in-day-month').val( pad( e.date.getDate(), 2) + ' ' + monthNames[e.date.getMonth()] );
			
			$('input[name="arrivalDate"]').val( e.date.getFullYear() + '' + pad((e.date.getMonth()+1*1), 2) + '' + pad( e.date.getDate(), 2) );
			checkinDay = new Date(e.date).setUTCHours(0,0,0,0)
		}
	});

	var checkout = $checkOutField.chenDatepicker({
		format: 'dd/mm/yyyy',
		autoPick: true,
		autoHide: true,
		date: null,
		startDate: tomorrow,
		pick: function (e) {
			$('.check-out-day-month').val( pad( e.date.getDate(), 2) + ' ' + monthNames[e.date.getMonth()] );
			// no departure date in booking engine. number of nights has to be calculated
			checkoutDay = new Date(e.date).setUTCHours(0,0,0,0)
			var diff = checkoutDay - checkinDay
			var nights = diff / (1000 * 60 * 60 * 24);
			$('input[name="nightsStay"]').val(nights)

		}
	});

	

	var dateOfVisitSpa = $('.booking__spa .date-of-visit').chenDatepicker({
		format: 'dd/mm/yyyy',
		autoPick: true,
		autoHide: true,
		date: null,
		startDate: nowTemp,
		pick: function (e) {
			var selectedDate = e.date;
            var day = ("0" + selectedDate.getDate()).slice(-2); // Ensure two-digit day
			console.log('Day is: ' + day);
            var month = monthNames[selectedDate.getMonth()]; // Get short month name
			console.log('Month is: ' + month);
            var year = selectedDate.getFullYear();

            // Update the inputs
            $('.date-of-visit').val(day);
			$('.visit-day-display').text(day);
            $('.date-of-visit-month').text(month);

            // Update the hidden input with YYYY-MM-DD format
            $('input[name="date"]').val(year + "-" + ("0" + (selectedDate.getMonth() + 1)).slice(-2) + "-" + day);

			// $('.booking__spa .date-of-visit-month').val( pad( e.date.getDate(), 2) + ' ' + monthNames[e.date.getMonth()] );
			
			// $('.booking__spa input[name="serviceDate"]').val( e.date.getFullYear() + '' + pad((e.date.getMonth()+1*1), 2) + '' + pad( e.date.getDate(), 2) );
			// checkinDay = new Date(e.date.getFullYear() + ',' + pad((e.date.getMonth()+1*1), 2) + ',' + pad( e.date.getDate(), 2)).setUTCHours(0,0,0,0)
		}
	});

	var dateOfVisitActivity = $('.booking__experience .date-of-visit').chenDatepicker({
		format: 'dd/mm/yyyy',
		autoPick: true,
		autoHide: true,
		date: null,
		startDate: nowTemp,
		pick: function (e) {
            var selectedDate = e.date;
            var day = ("0" + selectedDate.getDate()).slice(-2); // Ensure two-digit day
			console.log('Day is: ' + day);
            var month = monthNames[selectedDate.getMonth()]; // Get short month name
			console.log('Month is: ' + month);
            var year = selectedDate.getFullYear();

            // Update the inputs
            $('.date-of-visit').val(day);
			$('.visit-day-display-activity').text(day);
            $('.date-of-visit-month').text(month);

            // Update the hidden input with YYYY-MM-DD format
            $('input[name="date"]').val(year + "-" + ("0" + (selectedDate.getMonth() + 1)).slice(-2) + "-" + day);
        }
	});
}

document.addEventListener("DOMContentLoaded", function () {
    var forms = document.querySelectorAll(".booking__experience-day-form, .booking__spa-day-form");

	forms.forEach(function(form) {
		form.addEventListener("submit", function (event) {
			event.preventDefault(); // Prevent default form submission
	
			var baseURL = window.location.origin + "/spa-booking/#!/accommodation/search/date/";
			var dateInput = form.querySelector('input[name="date"]').value;
			var guestsInput = form.querySelector('input[name="numberGuests"]').value;
	
			if (!dateInput) {
				alert("Please select a date.");
				return;
			}
	
			// Convert date to YYYY-MM-DD format
			var selectedDate = new Date(dateInput);
			var year = selectedDate.getFullYear();
			var month = ("0" + (selectedDate.getMonth() + 1)).slice(-2); // Ensure two digits
			var day = ("0" + selectedDate.getDate()).slice(-2); // Ensure two digits
			var formattedDate = year + "-" + month + "-" + day;
	
			// Generate the next day's date
			var nextDay = new Date(selectedDate);
			nextDay.setDate(nextDay.getDate() + 1);
			var nextYear = nextDay.getFullYear();
			var nextMonth = ("0" + (nextDay.getMonth() + 1)).slice(-2);
			var nextDayNum = ("0" + nextDay.getDate()).slice(-2);
			var formattedNextDay = nextYear + "-" + nextMonth + "-" + nextDayNum;
	
			// Ensure guestsInput is a number and fallback to 2 if empty or invalid
			var guests = parseInt(guestsInput, 10) || 2;
	
			// Build the final URL with additional parameters
			var finalURL = baseURL + formattedDate + "/" + formattedNextDay + 
						   "?unit_category=944&occ=10x" + guests;
	
			// Redirect the user
			window.location.href = finalURL;
		});
	});
});

$(document).ready(function() {
    $('.booking__spa-date-container').on('click', '.visit-day-display, img', function() {
        var $input = $(this).closest('.booking__spa-date-container').find('.date-of-visit');
        setTimeout(function() {
            $input.trigger('focus');
			$input.chenDatepicker('show');
        }, 50);
    });
});
